import { render } from "./TheProfessionalCalendarEventUpdate.vue?vue&type=template&id=2baedd23&ts=true"
import script from "./TheProfessionalCalendarEventUpdate.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalCalendarEventUpdate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__